import styled from 'styled-components';
import { BoxButton, Input } from '@riac/design-system';
import { Select } from 'src/components/Select/Select';

export const FlexRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1em;
  justify-content: space-between;

  width: 100%;
  
  ${Input} {
    flex: 1 1 auto;
    margin: 0;
  }

  ${(props) => props.theme.desktop} {
    flex-wrap: nowrap;
  }
`;

export const AddressTypeSelect = styled(Select)`
  &&& {flex: 0 0 50%;}
  padding-right: 0.5em;
`;

export const FlexRowButtons = styled(FlexRow)`
  justify-content: flex-end;
  column-gap: 0.5em;
`;

export const Form = styled.form`
  display: flex;
  flex-flow: column nowrap;
  row-gap: 1em;

  margin-top: 1em;
`;

export const SubmitButton = styled(BoxButton)`
  margin-right: 15px;
`;

export const CancelButton = styled(BoxButton)`
  background: none;
  border: solid 2px ${({ theme }) => theme.gold[50]};
`;
